import {html} from "@polymer/polymer/polymer-element.js";
export const template = html`[[_displayValue]] [[_displayCountdown]]`;